import { render, staticRenderFns } from "./RewardPop.vue?vue&type=template&id=0765e568&scoped=true"
import script from "./RewardPop.vue?vue&type=script&lang=js"
export * from "./RewardPop.vue?vue&type=script&lang=js"
import style0 from "./RewardPop.vue?vue&type=style&index=0&id=0765e568&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0765e568",
  null
  
)

export default component.exports